__turbopack_context__.v({
  "box": "ProductCard-module-scss-module__030dEa__box",
  "image": "ProductCard-module-scss-module__030dEa__image",
  "title": "ProductCard-module-scss-module__030dEa__title",
});
